export class ClientOnboardingRequestModel {
  clientIds: string[];
  newEmailMapping: Record<string, string>;
  personalInvitationText: string;
  withPersonalInvitationText: boolean = false;
}
